export default __webpack_public_path__ + "static/media/bisewer.aea26ccd.jpg";